import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { InfoRoundIconSmall, Text, useTooltip } from '@frontend/design-system';
import { CellRendererType } from '../../constants';

export const CellRenderer = ({ type, children = '-' }: { type: string; children: string }) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ trigger: 'hover' });

  switch (type) {
    case CellRendererType.DISCLAIMERS:
      return children === '-' || !children ? (
        <Text css={commonTextStyle}>{children}</Text>
      ) : (
        <Text css={commonTextStyle} {...triggerProps}>
          <InfoRoundIconSmall css={hideForPrint} />
          <Tooltip {...tooltipProps} css={hideForPrint}>
            {children}
          </Tooltip>
          <Text css={printOnlyStyle}>{children}</Text>
        </Text>
      );
    default:
      return <Text css={[commonTextStyle]}>{children ?? '-'}</Text>;
  }
};

const commonTextStyle = css`
  color: ${theme.colors.neutral90};
  font-weight: ${theme.font.weight.regular};
  width: fit-content;
  word-break: break-all;
`;

const printOnlyStyle = css`
  display: none;

  @media print {
    display: flex;
  }
`;

const hideForPrint = css`
  @media print {
    display: none;
  }
`;
